

































import { Component, Prop, Vue, Watch } from 'vue-property-decorator'
import User from '@/users/entities/user'
import UsersService from '@/users/services/users-service'
import UserFilter from '@/users/entities/user-filter'
import isEqual from 'lodash/isEqual'
import isString from 'lodash/isString'
import Guid from '@/app/utils/guid'

@Component
export default class UserSelect extends Vue {
  @Prop({ default: null })
  private value!: User | string | null

  @Prop({ default: () => [] })
  private excluded!: (User | string)[]

  @Prop({ default: () => [] })
  private roles!: string[]

  @Prop({ type: Boolean, default: false })
  private returnObject!: boolean

  private item: User | null = null
  private items: User[] = []

  private loading = false
  private search: string = ''
  private filter = new UserFilter()

  private get excludedIds() {
    return this.excluded.map((i) => (isString(i) ? i : i.id))
  }

  @Watch('value')
  private async valueChanged(val: User | string | null) {
    await this.prefetchAsync(val)
  }

  @Watch('search')
  private async searchChanged(val: string, old: string) {
    if (val && val !== old) {
      this.filter.search = val
      await this.loadAsync()
    }
  }

  @Watch('excluded')
  private excludedChanged(val: (User | string)[], old: (User | string)[]) {
    if (isEqual(val, old) === false) {
      this.filter.excluded = val.map((i) => (isString(i) ? i : i.id))
      this.loadAsync()
    }
  }

  @Watch('roles')
  private rolesChanged(val: string[], old: string[]) {
    if (isEqual(val, old) === false) {
      this.filter.roles = val
      this.loadAsync()
    }
  }

  private async prefetchAsync(value: User | string | null) {
    if (value == null) {
      this.item = null
      return
    }

    let item: User | null = null

    if (isString(value)) {
      if (value !== Guid.empty()) {
        item = await UsersService.findOneAsync(value)
      }
    } else {
      item = value
    }

    if (item) {
      if (this.items.every((c) => c.id !== item?.id)) {
        // TODO: Sort.
        this.items.push(item)
      }
      this.item = item
      this.emitChange()
    }
  }

  private async loadAsync() {
    this.loading = true
    this.items = await UsersService.findAllAsync(this.filter)
    this.loading = false
  }

  private async emitChange() {
    this.$emit('input', this.returnObject ? this.item : this.item?.id)
    this.$emit('input:object', this.item)
  }

  private emitClear() {
    this.$emit('input', null)
    this.$emit('input:object', null)
  }

  private async mounted() {
    this.filter.excluded = this.excludedIds
    this.filter.roles = this.roles

    await this.loadAsync()
    // await this.prefetchAsync(this.value)
  }
}
